function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M16.111 14c.491 0 .889.358.889.8v2.4c0 .442-.398.8-.889.8H1.89C1.398 18 1 17.642 1 17.2v-2.4c0-.442.398-.8.889-.8h0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 7l5 5 5-5M9 12V0"
}));

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDE4IDE5Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSkiPgogICAgPHBhdGggc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMTUuMTExMTExMSwxNCBDMTUuNjAyMDMwOSwxNCAxNiwxNC4zNTgxNzIyIDE2LDE0LjggTDE2LDE3LjIgQzE2LDE3LjY0MTgyNzggMTUuNjAyMDMwOSwxOCAxNS4xMTExMTExLDE4IEwwLjg4ODg4ODg4OSwxOCBDMC4zOTc5NjkxMTEsMTggMCwxNy42NDE4Mjc4IDAsMTcuMiBMMCwxNC44IEMwLDE0LjM1ODE3MjIgMC4zOTc5NjkxMTEsMTQgMC44ODg4ODg4ODksMTQgTDAuODg4ODg4ODg5LDE0Ii8+CiAgICA8cG9seWxpbmUgc3Ryb2tlLXdpZHRoPSIyIiBwb2ludHM9IjMgNyA4IDEyIDEzIDciLz4KICAgIDxsaW5lIHgxPSI4IiB4Mj0iOCIgeTE9IjEyIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgDownload as ReactComponent };